// A single shimmer block. Sizing via props (width/height/radius) so it works
// inside CSS-Module components without needing utility classes.
//
//   <Skeleton width={120} height={14} />
//   <Skeleton height={220} radius={10} />   // width defaults to 100%
export function Skeleton({ width = '100%', height = 14, radius = 6, style = {}, className = '' }) {
  const w = typeof width === 'number' ? `${width}px` : width;
  const h = typeof height === 'number' ? `${height}px` : height;
  const r = typeof radius === 'number' ? `${radius}px` : radius;
  return (
    <div
      className={`te-shimmer ${className}`}
      style={{ width: w, height: h, borderRadius: r, ...style }}
      aria-hidden="true"
    />
  );
}

// A chart/table placeholder: a couple of header bars + a large body block,
// sized to roughly fill a dashboard card while its data loads.
export function ChartSkeleton({ height = 220 }) {
  return (
    <div style={{ padding: '4px 2px' }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 16 }}>
        <Skeleton width={160} height={16} />
        <Skeleton width={120} height={28} radius={8} />
      </div>
      <Skeleton height={height} radius={10} />
    </div>
  );
}

export default Skeleton;
